import React from 'react';
import BaseCreatePage from '../../_CustomComponents/BaseCreatePage';
import { connect } from "react-redux";
import { Portlet, PortletBody, PortletHeader } from "../../../../partials/content/Portlet";
import { Alert } from "react-bootstrap";
import * as paymentCertificateCrud from '../../../../crud/paymentCertificate.crud';
import BiDynamicForm from '../../../../partials/layout/BiDynamicForm';
import moment from 'moment';
import { FormattedMessage, injectIntl } from "react-intl";
import { withCreatePageProps } from '../../../../shared/hoc/withCreatePageProps';
import Common from '../../../../shared/common';
import { actionCodes, GetCurrencyCodes } from "../../../../shared/lookup";

class PaymentCreatePage extends BaseCreatePage {
    constructor(props) {
        super(props);
        this.currencyCodes = GetCurrencyCodes(props.intl);

        //if it's coming from create new via Clause/Type button, try to set default clause display value according to the clauseDisplay passed in location state from clause dropdown
        this.createDefaultClause = (((props.location || {}).state || {}).itemCustomProps || {}).clauseDisplay;
        
        this.state = {
            showAlert: true
        };
    }

    calculateSubTotal = (obj) => {
        const prc1 = obj.othercumulativeprice ? obj.othercumulativeprice : 0;
        const prc2 = obj.otheramountpaid ? obj.otheramountpaid : 0;
        return prc1 + prc2;
    }

    calculateAmountDue = (obj) => {
        const prc1 = obj.subtotalpay ? obj.subtotalpay : 0;
        const prc2 = obj.subtotalretain ? obj.subtotalretain : 0;
        return prc1 - prc2;
    }

    calculateSubTotalPreTax = (obj) => {
        const prc1 = obj.otheramountretain ? obj.otheramountretain : 0;
        const prc2 = this.props.contract.totalcertified;
        return prc1 - prc2;
    }

    calculateSubTotalPreTaxV2 = (obj) => {
        const prc1 = obj.otheramountretain ? obj.otheramountretain : 0;
        const prc2 = obj.lastpaymentcertificateamount ? obj.lastpaymentcertificateamount : 0;
        return prc1 - prc2;
    }

    calculateTotal = (obj) => {
        const prc1 = obj.othercertifiedpretax ? obj.othercertifiedpretax : 0;
        const prc2 = obj.othertaxamount ? obj.othertaxamount : 0;
        return prc1 + prc2;
    }

    formatCurrency = () => {
        const cur = this.currencyCodes.find(currency => currency.code === this.props.contract.currency)?.name || this.props.contract.currency;
        return cur;
    }

    submitHandler = (payment) => {

        payment.companyid = this.props.contract.companyid;
        payment.contractid = this.props.contract.contractid;
        payment.projectid = this.props.contract.projectid;
        payment.assessmentdatedisplay = moment(payment.assessmentdate).format('DD/MM/YYYY');
        // payment.paymentcertificateissueddatedisplay = moment().format('DD/MM/YYYY');
        payment.type = this.props.notificationType;
        payment.status = 'Not Communicated';
        payment.createdate = new Date();
        payment.createdatedisplay = moment().format('DD/MM/YYYY');
        payment.currency = this.props.contract.currency;

        // payment.applicationtype = this.props.applicationTypes;
        // payment.paymentduedatedisplay = moment(addWeeks(new Date(payment.assessmentdate), 2)).format('DD/MM/YYYY');
        // payment.paymentreceivedatedisplay = moment(addDays(new Date(payment.assessmentdate), this.props.globalResources.PAYMENT_PERIOD)).format('DD/MM/YYYY');
        payment.actioncode = actionCodes.CREATE;
        payment.workflowid = this.props.workflowItem.id;
        this.appendRelationship(payment);
        Common.PropertyConversionsBeforeNoticeSaveRequest(payment, this.props.customFields, this.props.contractUsers);
        paymentCertificateCrud.savePaymentCertificate(payment)
            .then(response => {
                this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'GENERAL.COMMUNICATON.DRAFT_SUCCESS' }), { variant: 'success', });
                try {
                    const createdID = Number(response.data);
                    this.props.navigate(this.props.workflowItem.paths.basePath + createdID);
                }
                catch {
                    this.props.navigate(this.props.workflowItem.paths.listPath);
                }
            })
            .catch(err => {
                this.props.enqueueSnackbar(err.toString(), { variant: 'error', key: "PersistentFormWarning", persist: true });
            });
    }

    render() {
        const { assetid } = ((this.props.location.state || {}).itemCustomProps || {});

        const { fields } = this.props.workflowItem;

        const bottomLabel = this.props.notificationType === 'Application' ? this.props.resources.PaymentAppliedPeriodLabel : this.props.resources.PaymentCertifiedPeriodLabel;
        const createFormConfig = {
            currencyCode: this.props.contract.currency,
            buttonResource: "GENERAL.FORMS.BUTTON_CREATE_DRAFT",
            fields: []
        };

        //trying to find value from the display of the clause dropdown passed in location state from clause dropdown
        let defaultClauseField = null;

        if (this.props.clauses && this.createDefaultClause) {
            const matchedClause = this.props.clauses.find(
                c => c.display === this.createDefaultClause
            );

            if (matchedClause) {
                defaultClauseField = matchedClause.field;
            }
        }

        if (this.props.clauses) {
            createFormConfig.fields.push(
                { label: fields.ApplicationType.label, dataField: 'paymenttype', editorType: 'dxSelectBox', editorOptions: { dataSource: this.props.clauses, valueExpr: 'field', displayExpr: 'display', defaultValue: defaultClauseField } })
        }
        if (this.props.notificationType === 'Application' && this.props.isCountOfUncompletedAssessmentDateActionsMoreThanZero()) {
            const payAssessActionsRaw = this.props.filteredManualActions.items
                .filter(a => a.type === 'PAY_ASSESS');
        
            const payAssessActions = payAssessActionsRaw
                .map(a => ({
                    value: a.duedate,
                    display: `Monthly Payment Assessment Due - ${moment(new Date(a.duedate)).format("DD/MM/YYYY")}`
                }));

            createFormConfig.fields.push({
                label: this.props.globalResources.PAYMENT_ASSESSMENT_LABEL,
                dataField: 'assessmentdate',
                required: fields.AssessmentDate.required,
                editorType: 'dxSelectBox',
                editorOptions: {
                    dataSource: payAssessActions,
                    valueExpr: 'value',
                    displayExpr: 'display'
                }
            });

            const contractorActionsRaw = this.props.contractorPaymentApplicationActions();
            
            const contractorActions = contractorActionsRaw
                .map(a => ({
                    value: a.duedate,
                    display: `Payment Application Due - ${moment(a.duedate).format("DD/MM/YYYY")}`
                }));

            createFormConfig.fields.push({
                label: (this.props.workflowsQA['21'] || {}).pageTitle + ' ' + this.props.intl.formatMessage({ id: "ACTIONS.FIELD.DUE_DATE" }),
                dataField: 'applicationdate',
                required: fields.AssessmentDate.required,
                dependOn: 'assessmentdate',
                dependOnValue: (item) => {
                    // if (item.applicationdate) {
                    //     return item.applicationdate;
                    // }

                    const selectedAssessmentDate = item.assessmentdate;

                    const closest = this.props.getClosestDate(
                        selectedAssessmentDate,
                        contractorActionsRaw,
                        'duedate'
                    );

                    const preSelectedValue = closest ? closest.duedate : null;

                    return preSelectedValue;
                },
                editorType: 'dxSelectBox',
                editorOptions: {
                    dataSource: contractorActions,
                    valueExpr: 'value',
                    displayExpr: 'display',
                    readOnly: true
                    //value: preSelectedValue//sets pre-selection
                }
            });
        } else {
            createFormConfig.fields.push({
                label: fields.AssessmentDate.label,
                dataField: 'assessmentdate',
                required: fields.AssessmentDate.required,
                editorType: 'dxDateBox',
                validation: {
                    type: 'range',
                    min: new Date(1900, 0, 1),
                    max: new Date(2079, 5, 6),
                    warning: this.props.intl.formatMessage({ id: "GENERAL.FORMS.INVALID_DATE" })
                }
            });
        }
        createFormConfig.fields.push(
            { label: fields.Summary.label, dataField: 'summary', required: fields.Summary.required, editorType: 'dxHtmlEditor' },
            { label: fields.Currency.label, value: this.formatCurrency },
            { label: fields.OtherCumulativePrice.label, dataField: 'othercumulativeprice', required: fields.OtherCumulativePrice.required, editorType: 'dxNumberBox' },
            { label: fields.OtherAmountPaid.label, dataField: 'otheramountpaid', required: fields.OtherAmountPaid.required, editorType: 'dxNumberBox' },
            { label: fields.SubTotalPay.label, dataField: 'subtotalpay', required: fields.SubTotalPay.required, editorType: 'dxNumberBox', value: this.calculateSubTotal },
            { label: fields.SubTotalRetain.label, dataField: 'subtotalretain', required: fields.SubTotalRetain.required, editorType: 'dxNumberBox', editorOptions: { min: 0 } },
            { label: fields.OtherAmountRetain.label, dataField: 'otheramountretain', required: fields.OtherAmountRetain.required, editorType: 'dxNumberBox', value: this.calculateAmountDue },
            { label: fields.LastPaymentCertificateAmount.label, dataField: 'lastpaymentcertificateamount', required: fields.LastPaymentCertificateAmount.required, editorType: 'dxNumberBox' },
        )
        if (this.props.contract.totalcertified != null) {
            const lastPaymentField = createFormConfig.fields.find(itm => itm.dataField === 'lastpaymentcertificateamount');
            lastPaymentField.value = () => this.props.contract.totalcertified;
        }

        if (this.props.taxEnabled) {
            createFormConfig.fields.push(
                { label: fields.SubTotalPay.label, dataField: 'othercertifiedpretax', required: fields.SubTotalPay.required, editorType: 'dxNumberBox', value: this.props.contract.totalcertified != null ? this.calculateSubTotalPreTax : this.calculateSubTotalPreTaxV2 },
                { label: fields.OtherTaxAmount.label, dataField: 'othertaxamount', required: fields.OtherTaxAmount.required, editorType: 'dxNumberBox', },
                { label: bottomLabel, dataField: 'othercertfiedamount', required: true, editorType: 'dxNumberBox', value: this.calculateTotal }
            )
        }
        else {
            createFormConfig.fields.push(
                { label: bottomLabel, dataField: 'othercertfiedamount', required: true, editorType: 'dxNumberBox', value: this.props.contract.totalcertified != null ? this.calculateSubTotalPreTax : this.calculateSubTotalPreTaxV2 }
            )
        }

        if (this.props.poNumberEnabled) {
            createFormConfig.fields.push(
                { label: fields.PurchaseOrderNumber.label, dataField: 'purchaseordernumber', required: fields.PurchaseOrderNumber.required, editorOptions: { defaultValue: this.props.contract.versionnumber } }
            )
        }

        return (
            <Portlet>
                <PortletHeader title={this.props.intl.formatMessage({ id: 'GENERAL.FORMS.CREATE_TITLE' }, { ITEM_NAME: this.props.workflowItem.pageTitle })} />
                <PortletBody style={{ maxWidth: 1000 }}>
                    {this.state.showAlert && (
                        <Alert variant="secondary" onClose={() => this.setState({ showAlert: false })} dismissible>
                            <p>
                                <FormattedMessage id="GENERAL.FORMS.WARNING_DRAFT" />
                            </p>
                        </Alert>
                    )}
                    {this.props.resources.WarningBanner && (
                        <Alert variant="warning" >
                            <p>
                                {this.props.resources.WarningBanner}
                            </p>
                        </Alert>
                    )}

                    <BiDynamicForm
                        onSubmitHandler={this.submitHandler}
                        config={createFormConfig}
                        customFields={(this.props.customFields || {}).COMMUNICATION}
                        assetFieldsEnabled={this.props.workflowItem.assetFieldsEnabled}
                        assetid={assetid}
                    />

                </PortletBody>
            </Portlet>
        );
    }
}

const mapStateToProps = store => ({
    contractUsers: store.contract.users,
    filteredManualActions: store.contract.filteredManualActions
});

export default injectIntl(withCreatePageProps(connect(mapStateToProps)(PaymentCreatePage)));
